import { useParams } from 'react-router-dom';
import { TBlockchain } from 'src/types';

export function useAddressAndChainParams(): {
  address: string;
  chain: TBlockchain;
} {
  const { id: address, chain } = useParams<{
    id: string;
    chain: TBlockchain;
  }>();

  if (!address) {
    throw new Error('Address is missing in URL parameters.');
  }

  if (!chain) {
    throw new Error('Chain is missing in URL parameters.');
  }

  return { address, chain };
}
